import { DataGridToolbar } from '@/components/DataGrid';
import { CheckReceiptMainButton } from '../actions';

export const ReceiptInfoDataGridMainToolbar = () => (
  <DataGridToolbar>
    <CheckReceiptMainButton />
  </DataGridToolbar>
);
